export default __webpack_public_path__ + "static/media/i6500.181acb38.jpg";